import { render, staticRenderFns } from "./edit-regalo.vue?vue&type=template&id=85d82df2"
import script from "./edit-regalo.vue?vue&type=script&lang=ts"
export * from "./edit-regalo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports